// @ts-expect-error: Flow to TS migration.
import { set } from "splitster-redux"
import Cookies from "js-cookie"
import * as R from "ramda"
import { get } from "@kiwicom/frontend-common/utils/get"
import has from "@kiwicom/frontend-common/utils/has"
import castArray from "@kiwicom/frontend-common/utils/castArray"
import { showModal } from "@kiwicom/frontend-common/services/modals/actions"
import { hashBannerText } from "@kiwicom/frontend-common/services/remoteConfig/bannerHelper"
import { setBanner } from "@kiwicom/frontend-common/services/remoteConfig/actions"

import { Banners } from "./banner.types"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const splitsterHasTest = (testId: string, splitsterTests: any) => has([testId], splitsterTests)

const bindWindowGlobalFunctions = () => {
  // ==== Remote configuration
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
  window.globalSetExponeaBanner = (text: Banners, showOnMobile: boolean = false) => {
    const closedBanners = castArray(Cookies.getJSON("closedBanners"))
    const banners = R.compose(
      // @ts-expect-error: Flow to TS migration.
      R.filter((banner) => !closedBanners.includes(hashBannerText(banner.text))),
      castArray,
    )(text)

    if (banners.length) {
      // @ts-expect-error: Flow to TS migration.
      window.reduxStore.dispatch(setBanner(banners, showOnMobile)) // ensure array is inserted
    }
  }
  // @ts-expect-error: Flow to TS migration.
  window.globalShowMaintenanceModal = () => {
    // @ts-expect-error: Flow to TS migration.
    window.reduxStore.dispatch(showModal("maintenance"))
  }

  // ==== Splitster
  // @ts-expect-error: Flow to TS migration.
  window.toggleSplitsterTest = (testId: string) => {
    // @ts-expect-error: Flow to TS migration.
    const splitsterTests = get(["splitster", "state", "tests"], window.reduxStore.getState())

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!splitsterHasTest(testId, splitsterTests)) return

    // @ts-expect-error: Flow to TS migration.
    const { winningVariant, variants } = get(testId, splitsterTests)

    const variantId = R.compose(
      get("id"),
      R.head,
      R.filter((variant) => variant !== winningVariant),
    )(variants)

    // @ts-expect-error: Flow to TS migration.
    window.reduxStore.dispatch(set(testId, variantId, true))
  }
  // @ts-expect-error: Flow to TS migration.
  window.setSplitsterTestVariant = (testId: string, variantId: string) => {
    // @ts-expect-error: Flow to TS migration.
    const splitsterTests = get(["splitster", "tests"], window.reduxStore.getState())

    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!splitsterHasTest(testId, splitsterTests)) return

    // @ts-expect-error: Flow to TS migration.
    window.reduxStore.dispatch(set(testId, variantId, true))
  }
}

export default bindWindowGlobalFunctions
